import Hub from './Hub';
import HubOG from './HubOG';
import { useDashboardV3 } from '../contexts/DashboardV3Context';
import { useActiveSpace } from '../spaces/useActiveSpace';
import { useSpaceLayout, layoutIdOfView } from '../spaces/useSpaceLayout';

/**
 * The home page (/ and /hub).
 *   HubOG.jsx  is the OG Dashboard: a saved copy of the home page exactly as it was before the rebuild. Do not edit it.
 *   Hub.jsx    is the home page being rebuilt. It is the Default Space's dashboard as it stands, and with a `spaceView` it is the Sales Space / Admin Space dashboard, or a page
 *              layout made in Settings > User Interface > Spaces Builder (spaceView "layout" with the layout itself as `spaceLayout`).
 * Which one a person sees is decided by Settings > User Interface (see resolveOgHome in contexts/DashboardV3Context.jsx): OG Dashboard is on to begin with, which keeps
 * the OG Dashboard for everyone. Once the new home page is on for a person, their Space (Settings > User Interface > User Spaces) decides the dashboard:
 *   Default Space -> the current home page, Sales Space -> Hub with spaceView="sales", Admin Space -> Hub with spaceView="admin", a Space with a page layout -> that layout.
 */
const HomeGate = (props) => {
  const { ogHome } = useDashboardV3();
  const space = useActiveSpace(!ogHome);
  const layoutId = layoutIdOfView(space.view);
  const { layout, ready: layoutReady } = useSpaceLayout(!ogHome ? layoutId : null);
  if (ogHome) return <HubOG {...props} />;
  // Until the person's Space (and its layout, if it has one) is known nothing is drawn, so the wrong dashboard never flashes up first.
  if (!space.ready || !layoutReady) return <div className="min-h-screen" data-testid="home-space-loading" />;
  if (layoutId) {
    // A layout that cannot be found (it was deleted, or the server was out of reach) shows the Default Space's home page.
    return layout ? <Hub {...props} spaceView="layout" spaceLayout={layout} /> : <Hub {...props} spaceView={null} />;
  }
  return <Hub {...props} spaceView={space.view === 'sales' || space.view === 'admin' ? space.view : null} />;
};

export default HomeGate;
